(function ($) {

    if($('.two-col-tabs').length > 0) {

        $(document).ready(function () {
            $.each($('.two-col-tabs .tab-content .inner-wrapper'), function (i) {
                var content = $(this).clone();
                $.each($('.two-col-tabs .tab-items'), function (j) {
                    if (j == i) {
                        $('<div/>')
                            .attr({class: "mobile-option"}).html(content)
                            .appendTo($(this));
                    }
                })
            });
            if ($('.two-col-tabs .tab-items .inner-wrapper').hasClass("selected")) {
                $('.two-col-tabs .tab-btn').removeClass("selected");
            }
        });

        $('.two-col-tabs').css("opacity", "1");
        $('.two-col-tabs .tab-content .inner-wrapper').first().addClass("selected");
        $('.two-col-tabs .tab-btn .tab-items').first().addClass("selected");
        $('.two-col-tabs .tab-btn .tab-items').click(function () {
            $(this).addClass("selected").siblings().removeClass("selected");
        });

        function makeSlider() {
            $('.two-col-tabs .tab-btn').slick({
                infinite: false,
                autoplay: false,
                vertical: true,
                verticalSwiping: false,
                slidesToScroll: 1,
                slidesToShow: 3,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                ]
            });

        };makeSlider();

        $(function () {
            $('.two-col-tabs .tab-btn .tab-items').on('click', function (e) {

                var clickId = $(this).index();
                $(this).addClass('selected').siblings().removeClass('selected');
                $('.two-col-tabs .tab-content .inner-wrapper').eq(clickId).addClass('selected').siblings().removeClass('selected');
            });
        });

        $(window).on("resize", function () {
            if ($(window).width() < 992) {
                if ($(".two-col-tabs .tab-btn").hasClass("slick-initialized")) {
                    $('.two-col-tabs .tab-btn').slick("unslick");
                }
            } else {
                if (!$(".two-col-tabs .tab-btn").hasClass("slick-initialized")) {
                    makeSlider();
                }
            }
            setTimeout(function () {
                $(".two-col-tabs .slick-prev").click();
            }, 10);
        }).resize();

    }

})(jQuery);